// extracted by mini-css-extract-plugin
export default {"tabdetails":"Tab_tabdetails__XDSyh","tabactions":"Tab_tabactions__ubPsJ"};